export default "/Frontend/dist/ppt-required.463116ab00107fcf2bf5fe8b198bc6cf.svg";